import api from './api';

const state = {
	roles: null,
	loading: false,
	permissions: null,
	success: false,
	error: false,
	addError: false,
	loadingError: false,
	message: '',
};

const getters = { roleNames: (state) => state.roles.map((r) => r.name) };

const mutations = {
	setRoles(state, { roles }) {
		if (state.roles === null) {
			state.roles = roles;
		} else {
			state.roles.splice(0, state.roles.length, ...roles);
		}
	},
	updateRoles(state, { id, payload, field }) {
		const idx = state.roles.findIndex((role) => role.id == id);
		if (idx === -1) return;
		state.roles[idx][field] = payload;
	},
	addRole(state, { role }) {
		if (state.roles && Array.isArray(state.roles)) {
			state.roles.push(role);
		}
	},
	setPermissions(state, { permissions }) {
		state.permissions = permissions;
	},
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
		state.error = false;
		state.loadingError = false;
	},
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	showError(state, { message }) {
		state.message = message;
		state.error = true;
	},
	hideError(state) {
		state.error = false;
		state.addError = false;
		state.loadingError = false;
		state.message = '';
	},
	showAddError(state, { message }) {
		state.message = message;
		state.addError = true;
	},
	showLoadingError(state, { message }) {
		state.loadingError = true;
		state.message = message;
	},
};

const actions = {
	async loadRoles({ state, commit, rootGetters, dispatch }, showDeleted) {
		commit('startLoading');
		return api
			.getRoles(showDeleted)
			.then(async (response) => {
				const roles = response.data;
				commit('setRoles', { roles });
				commit('stopLoading');
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showLoadingError', { message });
			});
	},
	async loadPermissions({ state, commit, rootGetters }) {
		commit('startLoading');
		return api
			.getPermissions()
			.then((response) => {
				const permissions = response.data;
				commit('setPermissions', { permissions });
				commit('stopLoading');
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showLoadingError', { message });
			});
	},
	addRole({ state, commit, rootGetters, dispatch }, role) {
		return api
			.addRole(role)
			.then((response) => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				commit('addRole', { role: response.data });
				return response.data;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showAddError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
			});
	},
	updateRole({ state, commit, rootGetters }, { id, field, payload }) {
		return api
			.updateRole(id, field, payload)
			.then(() => {
				commit('showSuccess');
				commit('updateRoles', { id, payload, field });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
			});
	},
	deleteRole({ state, commit, rootGetters, dispatch }, role) {
		var result;
		let payload;
		if (!role.deleted) {
			result = api.deleteRole(role);
			payload = true;
		} else {
			result = api.updateRole(role.id, 'deleted', false);
			payload = false;
		}
		return result
			.then(() => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				commit('updateRoles', { id: role.id, payload: payload, field: 'deleted' });
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
			});
	},
	async updateRoles({ commit }, roles) {
		try {
			await api.updateRoles(roles);
			commit('showSuccess');
			window.setTimeout(() => {
				commit('hideSuccess');
			}, 1500);
		} catch (err) {
			const message = err?.response?.data?.message;
			commit('showError', { message });
			window.setTimeout(() => {
				commit('hideError');
			}, 3000);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
